import { ElementRef, OnDestroy, OnInit, Optional, Self, Directive } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive()
export abstract class ControlValueAccessorTemplate implements OnInit, OnDestroy, ControlValueAccessor {
  OnChangeFn = self => self;
  OnTouchedFn = self => self;
  OnValidator = self => self;

  protected classSubs: Subscription;

  protected nativeElement = null;
  /**
   * control is received via [formControl] or [formControlName]
   */
  constructor(
    @Optional() @Self() public ngControlDir: NgControl,
    el: ElementRef
  ) {
    if (ngControlDir) {
      ngControlDir.valueAccessor = this;
    }
    if (el) {
      this.nativeElement = el.nativeElement;
    }
  }

  ngOnInit(): void {}

  /**
   * CVA default communication interface method
   * @param fn
   */
  public registerOnChange(fn: any): void {
    this.OnChangeFn = fn;
  }

  /**
   * CVA default communication interface method
   * @param fn
   */
  public registerOnTouched(fn: any): void {
    this.OnTouchedFn = fn;
  }

  /**
   * CVA default communication interface method
   * @param fn
   */
  public registerOnValidatorChange?(fn: () => void): void {
    this.OnValidator = fn;
  }

  /**
   * Abstract CVA contract method
   * @param obj
   */
  abstract writeValue(obj: any): void;

  /**
   * Abstract CVA contract method
   * @param isDisabled
   */
  abstract setDisabledState?(isDisabled: boolean): void;

  ngOnDestroy(): void {
    // required by untilDestroyed
    if (this.classSubs) {
      this.classSubs.unsubscribe();
    }
    if (this.nativeElement) {
      this.nativeElement = null;
    }

    this.OnChangeFn = null;
    this.OnTouchedFn = null;
    this.OnValidator = null;
  }
}
